import { getcolumns } from "./utilities";
import { useTranslation } from "react-i18next";
import FilterComponent from "./FilterComponent";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allSharedComponents } from "../../../../shared";
import { paymentActions } from "../../../../redux/actions";
import { translationConstants } from "../../../../constants";
import {
  changeTableSortIcons,
  getSortDirectionProperty,
} from "../../../../system";

const { DataTable, ExportComponent } = allSharedComponents;

let sortingInProgress = false;
const defaultQueryExpression = "id != null ";

const initialGridState = {
  length: 10,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: defaultQueryExpression,
};

const PaymentHistory = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const paymentHistoryData = useSelector(
    (state) => state.PaymentReducer.adminPaymentHistory
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const [rowData, setRowData] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [columns, setColumns] = useState(getcolumns(t, direction));
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(gridState.pageNumber);

  useEffect(() => {
    setColumns(getcolumns(t, direction));
    // eslint-disable-next-line
  }, [i18n.dir()]);

  useEffect(() => {
    dispatch(paymentActions.adminPaymentHistory(gridState));
    sortingInProgress = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    setRowData(paymentHistoryData?.pageData?.paymentHistory);
    setTotalRows(paymentHistoryData?.page?.totalElements);
    // eslint-disable-next-line
  }, [paymentHistoryData]);

  const onChangePage = (pageNumber) => {
    if (!sortingInProgress) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const onSort = (sortedColumn) => {
    sortingInProgress = true;
    setColumns(changeTableSortIcons(columns, sortedColumn));
    const columnDirection = getSortDirectionProperty(sortedColumn);
    setDefaultPage(gridState.pageNumber);
    setGridState({
      ...gridState,
      orderBy: columnDirection
        ? `${sortedColumn.id} ${columnDirection}`
        : "id desc",
    });
  };

  const exportData = () => {
    let dataToSend = {
      ...gridState,
      length: 0,
      orderBy: gridState.orderBy,
    };
    dispatch(paymentActions.exportPaymentHistory(dataToSend));
  };

  return (
    <div className="UserDiv">
      <div>
        <div className="row">
          <div className="col-6">
            <p className="UserTabHeading">
              {t(translationConstants.PAYMENT_HISTORY)}
            </p>
          </div>
          <div className="col-12 col-sm-6 d-flex flex-column justify-content-md-end">
            <p className="cometition-detail-payment-heading">
              {t(translationConstants.TOTAL_PAYMENT)}
            </p>
            <p className="cometition-detail-payment-text">
              {translationConstants.SAR}{" "}
              {paymentHistoryData?.pageData?.totalAmount || 0}
            </p>
          </div>
        </div>

        <div className="tableContainer">
          <FilterComponent
            gridState={gridState}
            setGridState={setGridState}
            defaultQueryExpression={defaultQueryExpression}
          >
            <ExportComponent
              isServerSide
              onClick={exportData}
              filename={t(translationConstants.PAYMENT_HISTORY)}
            />
          </FilterComponent>

          <DataTable
            isShowTimezone={true}
            onSort={onSort}
            items={rowData}
            columns={columns}
            gridState={gridState}
            paginationResetDefaultPage
            onChangePage={onChangePage}
            paginationTotalRows={totalRows}
            paginationDefaultPage={defaultPage}
            onChangeRowsPerPage={onChangeRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
